module.exports = __webpack_public_path__ + "static/media/103.2d68c6c1.png";